var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagramCircularFilled = function SvgInstagramCircularFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 22.75H9.99a4.745 4.745 0 0 1-4.74-4.74V9.99a4.745 4.745 0 0 1 4.74-4.74h8.02a4.745 4.745 0 0 1 4.74 4.74v8.02a4.745 4.745 0 0 1-4.74 4.74ZM9.99 6.708A3.285 3.285 0 0 0 6.708 9.99v8.02a3.285 3.285 0 0 0 3.282 3.282h8.02a3.285 3.285 0 0 0 3.282-3.281V9.99a3.285 3.285 0 0 0-3.282-3.282H9.99Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.375A4.38 4.38 0 0 1 9.625 14 4.38 4.38 0 0 1 14 9.625 4.38 4.38 0 0 1 18.375 14 4.38 4.38 0 0 1 14 18.375Zm0-7.292A2.92 2.92 0 0 0 11.083 14 2.92 2.92 0 0 0 14 16.917 2.92 2.92 0 0 0 16.917 14 2.92 2.92 0 0 0 14 11.083Zm4.648-.729a1.003 1.003 0 1 0 0-2.005 1.003 1.003 0 0 0 0 2.005Z",
    fill: "#fff"
  })));
};

export default SvgInstagramCircularFilled;